export default __webpack_public_path__ + "static/accents-role-do-41352ccb56194f989902db1bd8bbad4e80da224e08ccbf9d0f514c15049e7d99.png";